import { z } from "zod";

const publicEnvSchema = z.object({
  VITE_APP_NAME: z.string().trim().min(1, "VITE_APP_NAME must not be empty"),
  VITE_PUBLIC_BASE_URL: z.string().url("VITE_PUBLIC_BASE_URL must be an absolute URL"),
  VITE_STRIPE_PUBLISHABLE_KEY: z.string().optional().default("")
});

let cachedEnv: z.infer<typeof publicEnvSchema> | null = null;

export function getPublicEnv() {
  if (cachedEnv) {
    return cachedEnv;
  }

  const fallbackBaseUrl = typeof window !== "undefined" ? window.location.origin : "http://127.0.0.1";
  const parsed = publicEnvSchema.safeParse({
    VITE_APP_NAME: import.meta.env.VITE_APP_NAME || "Society Tickets",
    VITE_PUBLIC_BASE_URL: import.meta.env.VITE_PUBLIC_BASE_URL || fallbackBaseUrl,
    VITE_STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ""
  });
  if (!parsed.success) {
    const issue = parsed.error.issues[0];
    throw new Error(issue ? `${issue.path.join(".")}: ${issue.message}` : "Invalid public env");
  }

  cachedEnv = parsed.data;
  return cachedEnv;
}
